import React from 'react';
import RenderIf from '../RenderIf/RenderIf';
import Translate from '../Translate/Translate';
import {FormControlsProps} from '../../@types/components/Form';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

export default function FormControls<Model extends IEmptyModel = IEmptyModel>(props: FormControlsProps<Model>) {
    const controls = (
            Array.isArray(props.controls) ? props.controls : [props.controls]
    ).map((item, i) => {
        if (typeof item === 'string') {
            item = {
                type: 'submit',
                className: 'btn btn-primary',
                label: item,
            };
        }

        if (!item || !('type' in item)) {
            return null;
        }

        const key = `${props.formName}-${item.label}-${item.type}-${i}-button`;
        const id = `${props.formName}@${item.label}`;

        return <button type={item.type as any} className={item.className} id={id} key={key}>
            <RenderIf expression={item.icon}><i className={item.icon}/></RenderIf>
            <Translate message={item.label}/>
        </button>;
    });

    return <>{controls}</>;
}
